export const blockIconsTravelLiquorNew = (
	<span className='material-symbols-outlined'>liquor</span>
);
